import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsAddonsOauthRoute: InvariantJiraRoute = {
	name: 'global-settings-addons-oauth',
	path: '/secure/oauth-credentials',
};
